/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModCaoWages: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M1 1V12H8.051C8.09 12.348 8.162 12.682 8.275 13H0V1H1Z' />
			<path d='M13 7.0508V1.9998H11V7.2758C11.472 7.1078 11.971 6.9998 12.5 6.9998C12.6261 6.9998 12.7479 7.01667 12.8698 7.03355C12.9131 7.03955 12.9565 7.04555 13 7.0508Z' />
			<path d='M8 5H10V7.76C8.927 8.479 8.201 9.652 8.051 11H8V5Z' />
			<path d='M12.3982 13.8637C12.7542 13.8637 13.0492 13.7597 13.2832 13.5527C13.5172 13.3457 13.6422 13.0897 13.6582 12.7847H15.0002C14.9842 13.1797 14.8612 13.5477 14.6312 13.8897C14.4002 14.2317 14.0882 14.5017 13.6932 14.7007C13.2992 14.9007 12.8732 14.9997 12.4162 14.9997C11.5292 14.9997 10.8262 14.7127 10.3062 14.1387C9.7872 13.5647 9.5272 12.7717 9.5272 11.7597V11.6137C9.5272 10.6487 9.7852 9.8757 10.3012 9.2957C10.8162 8.7157 11.5192 8.4257 12.4102 8.4257C13.1642 8.4257 13.7782 8.6457 14.2532 9.0847C14.7272 9.5247 14.9762 10.1017 15.0002 10.8167H13.6582C13.6422 10.4527 13.5182 10.1547 13.2862 9.9197C13.0542 9.6857 12.7582 9.5687 12.3982 9.5687C11.9372 9.5687 11.5822 9.7357 11.3322 10.0697C11.0822 10.4037 10.9552 10.9097 10.9512 11.5897V11.8187C10.9512 12.5057 11.0752 13.0187 11.3232 13.3567C11.5712 13.6947 11.9292 13.8637 12.3982 13.8637Z' />
			<path d='M5 11H7V3H5V11Z' />
			<path d='M4 11H2V7H4V11Z' />
		</Svg>
	);
};

export { ModCaoWages };
